import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageOkcmNotlegacy} from "../../../../../../api/build";


@Component({
  selector: 'app-dict-qref-okcmNotlegacy',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefOkcmNotlegacyViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-6 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="kod"
                         name="ncm"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['ncm','kod']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.kod }} </b>
          {{ item.ncm }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <b> {{ item.kod }} </b>
          {{ item.ncm }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefOkcmNotlegacyViewComponent extends ViewDictionaryBase<PageOkcmNotlegacy> {
  getDictionary = this.dictSrv.getQrefOkcmNotlegacyList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
